import { Route } from 'react-router-dom';

//тут tabs это user.tabs
export const getRoutesAuthorized = (routes: any, tabs: any) => {
  return Object.keys(routes)
    .filter((key) => {
      const isPublic = routes[key].slug === 'all';

      if (isPublic) {
        return isPublic;
      }

      // const tab = find(tabs, { slug: routes[key].slug });

      const tab = tabs.get(routes[key].slug);

      //возможно сделать подсовывание 403 страницы когда вкладка есть но она false
      // return tab?.rights?.read || isPublic;
      return (
        tab?.rights.read ||
        isPublic ||
        routes[key].additionalAccessSlugs?.some(
          (slug: string) => tabs.get(slug)?.rights.read
        )
      );
    })
    .map((key) => {
      const route = routes[key];

      return (
        <Route key={route.slug} path={route.link} element={route.Component} />
      );
    });
};
